module.exports = __webpack_public_path__ + "media/mypage/images/icons/sp_shikaku-53700a9cf15ec3b091e1750c376ef4b4.png";